var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from 'react';
import { httpClient } from '../services/http/httpClient';
import { HoverOverlay, FormatTooltip } from '../general';
import { Loader } from '../index';
function Relationship(props) {
    var attribute = props.attribute, data = props.data, detail = props.detail, baseUrl = props.baseUrl;
    var _a = useState(_jsx(Loader, { size: "sm" })), contents = _a[0], setContents = _a[1];
    var endpoint = '/' + data['type'] + '/' + data['id'];
    var loadRelationship = function () {
        httpClient().get(endpoint, {
            baseURL: baseUrl
        }).then(function (res) {
            // error if endpoint doesn't return 200
            if (res.status !== 200) {
                throw Error();
            }
            var apiData = res.data.data;
            setContents(_jsx(FormatTooltip, { contents: apiData['attributes'] }));
        }).catch(function (error) {
            setContents('Object cannot be found: ' + error.message);
        });
    };
    if (data['id'] === null || data['id'] === "")
        return _jsx(_Fragment, {});
    var box = (_jsx(HoverOverlay, __assign({ placement: 'auto', contents: contents, onHover: function () { return loadRelationship(); }, delay: 250 }, { children: _jsx("div", __assign({ className: 'link-box' }, { children: data['attributes'][attribute] })) })));
    if (detail) {
        return (_jsx("a", __assign({ href: endpoint }, { children: box })));
    }
    return box;
}
export default Relationship;
